import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SITE_NAME = 'Velireo Skin';
const SITE_URL = 'https://velireoskin.com';
const DEFAULT_OG_IMAGE = 'https://storage.googleapis.com/gpt-engineer-file-uploads/0Jynv5oeJ4VEnwITcpwryMMFatn2/social-images/social-1769905371535-7.png';

interface SEOProps {
  title: string;
  description: string;
  ogImage?: string;
  canonical?: string;
  noIndex?: boolean;
  ogType?: 'website' | 'product' | 'article';
  articleMeta?: {
    publishedTime: string;
    modifiedTime?: string;
    author?: string;
  };
}

const SEO = ({ title, description, ogImage, canonical, noIndex, ogType = 'website', articleMeta }: SEOProps) => {
  const { pathname } = useLocation();
  const fullTitle = title.includes(SITE_NAME) ? title : `${title}｜${SITE_NAME}`;
  const url = canonical || `${SITE_URL}${pathname}`;
  const image = ogImage || DEFAULT_OG_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="zh_TW" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />

      {articleMeta && (
        <>
          <meta property="article:published_time" content={articleMeta.publishedTime} />
          {articleMeta.modifiedTime && <meta property="article:modified_time" content={articleMeta.modifiedTime} />}
          <meta property="article:author" content={articleMeta.author || SITE_NAME} />
        </>
      )}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
